export const ADMIN_TOKEN_KEY = "admin-token";
export const ADMIN_REFRESH_TOKEN_KEY = "admin-refresh-token";
export const ADMIN_EMAIL_KEY = "admin-email";
export const CONTRACT_TOKEN_KEY = "contract-token";
